<template>
  <div>xnserve Pro ©2021 by Shanghai biaoxin Network Technology Co. Ltd</div>
</template>

<script>
export default {};
</script>
